import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

function useSurveyQuestions({ token }) {
  const fetchSurveyQuestions = async () => {
    try {
      const { data } = await api.get('/questions/', {
        headers: { Authorization: token },
      });
      return data;
    } catch (error) {
      throw new Error('Failed to fetch Question List');
    }
  };

  const queryKey = ['questionList'];

  const { data, error, isLoading } = useQuery({
    queryKey,
    queryFn: fetchSurveyQuestions,
    gcTime: Infinity,
    staleTime: Infinity,
  });

  return {
    questions: data,
    isLoading,
    error,
  };
}

export default useSurveyQuestions;
